import request from './request'

const teacherAffairsApi = {
  // ==================== 事务配置 ====================
  getConfig: () => request.get('/teacher-affairs/config/'),

  // ==================== 值班管理 ====================
  getDutyWindows: (params) => request.get('/teacher-affairs/duty/windows/', { params }),
  getDutySchedules: (params) => request.get('/teacher-affairs/duty/schedules/', { params }),
  getDutyCalendar: (year, month, dutyType) =>
    request.get('/teacher-affairs/duty/calendar/', { params: { year, month, duty_type: dutyType } }),
  signUpDuty: (data) => request.post('/teacher-affairs/duty/sign-up/', data),
  cancelDutySignUp: (id) => request.delete(`/teacher-affairs/duty/sign-up/${id}/`),

  // ==================== 加班管理 ====================
  getOvertimeList: (params) => request.get('/teacher-affairs/overtime/', { params }),
  createOvertime: (data) => request.post('/teacher-affairs/overtime/', data),
  updateOvertime: (id, data) => request.put(`/teacher-affairs/overtime/${id}/`, data),
  deleteOvertime: (id) => request.delete(`/teacher-affairs/overtime/${id}/`),
  getOvertimeStats: (params) => request.get('/teacher-affairs/overtime/statistics/', { params }),

  // ==================== 请假管理 ====================
  getLeaveList: (params) => request.get('/teacher-affairs/leave/', { params }),
  // 我的请假：强制只看自己的（admin 用教师端登录也不该看到全校记录）
  getMyLeaveList: (params) =>
    request.get('/teacher-affairs/leave/', { params: { ...params, mine_only: true } }),
  createLeave: (data) => request.post('/teacher-affairs/leave/', data),
  updateLeave: (id, data) => request.put(`/teacher-affairs/leave/${id}/`, data),
  cancelLeave: (id) => request.delete(`/teacher-affairs/leave/${id}/`),
  uploadAttachment: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/teacher-affairs/leave/upload-attachment/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  getLeaveBalance: (teacherId, academicYear) =>
    request.get(`/teacher-affairs/leave/balance/${teacherId}/`, { params: { academic_year: academicYear } }),
  getLeaveStats: (params) => request.get('/teacher-affairs/leave/statistics/', { params }),
  // 上传请假凭证（病假必传挂号凭证，后端会强校验）
  // 请假天数试算（按校历教学日，后端与提交时用同一套算法）
  calculateLeaveDays: (data) => request.post('/teacher-affairs/leave/calculate-days/', data),

  // ===== 管理端（admin/staff）=====
  // 管理速览：待审批请假 / 待安排代课 / 本月加班 / 本月请假 / 在册教师
  getAdminOverview: () => request.get('/teacher-affairs/admin/overview/'),
  // 待审批请假（全校）
  getPendingLeaves: (params) =>
    request.get('/teacher-affairs/leave/', { params: { ...params, status: 'pending' } }),
  // 审批请假（通过 / 驳回）
  approveLeave: (id, data) => request.post(`/teacher-affairs/leave/${id}/approve/`, data),
  // 待安排代课
  getPendingSubstitutes: (params) =>
    request.get('/teacher-affairs/substitute/impacts/', { params: { ...params, status: 'pending' } }),
  // 候选代课教师
  getSubstituteCandidates: (impactId, limit = 10) =>
    request.get('/teacher-affairs/substitute/candidates/', { params: { impact_id: impactId, limit } }),
  // 指派代课
  createSubstituteAssignment: (data) =>
    request.post('/teacher-affairs/substitute/assignments/', data),
  uploadAttachment: (formData) =>
    request.post('/teacher-affairs/leave/upload-attachment/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    }),

  // ==================== 倒课与代课 ====================
  // 受影响课时（教师确认用）
  getLeaveImpacts: (leaveId) => request.get(`/teacher-affairs/substitute/leave/${leaveId}/impacts/`),
  // 自动识别受影响课时（依赖校历；未配置校历时后端会返回提示）
  detectLeaveImpacts: (leaveId, data) =>
    request.post(`/teacher-affairs/substitute/leave/${leaveId}/detect/`, data || {}),
  // 标记某节课的处理方式（免处理 / 无需倒课 等）
  updateLeaveImpact: (impactId, data) =>
    request.put(`/teacher-affairs/substitute/impacts/${impactId}/`, data),
  // 我的代课（被安排代课了哪些节 + 累计代课费）
  getMySubstitute: () => request.get('/teacher-affairs/substitute/my/'),
}

export default teacherAffairsApi
